import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "condition-group"
}
const _hoisted_2 = { class: "group-operator" }
const _hoisted_3 = {
  key: 0,
  class: "connector"
}
const _hoisted_4 = { class: "child-row" }
const _hoisted_5 = ["aria-label", "onClick"]
const _hoisted_6 = {
  key: 0,
  class: "empty"
}
const _hoisted_7 = {
  key: 1,
  class: "condition-comparison"
}
const _hoisted_8 = { class: "comparison-label" }
const _hoisted_9 = ["value"]

import StudioSelectField from "../../StudioSelectField.vue";
import { createConditionComparison, createConditionGroup, type VisualCondition, type ComparisonOperator } from "../types/VisualCondition";
import ConditionValueEditor from "./ConditionValueEditor.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionTreeEditor',
  props: {
    modelValue: {},
    depth: { default: 0 }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const comparisons: { value: ComparisonOperator; label: string }[] = [
  { value: "==", label: "等于 =" }, { value: "!=", label: "不等于 ≠" },
  { value: ">=", label: "大于等于 ≥" }, { value: ">", label: "大于 >" },
  { value: "<=", label: "小于等于 ≤" }, { value: "<", label: "小于 <" },
];
function updateChild(index: number, value: VisualCondition) {
  if (props.modelValue.kind !== "group") return;
  emit("update:modelValue", { ...props.modelValue, children: props.modelValue.children.map((child, i) => i === index ? value : child) });
}
function add(group: boolean) {
  if (props.modelValue.kind !== "group") return;
  emit("update:modelValue", { ...props.modelValue, children: [...props.modelValue.children, group ? createConditionGroup() : createConditionComparison()] });
}
function remove(index: number) {
  if (props.modelValue.kind !== "group") return;
  emit("update:modelValue", { ...props.modelValue, children: props.modelValue.children.filter((_, i) => i !== index) });
}

return (_ctx: any,_cache: any) => {
  const _component_ConditionTreeEditor = _resolveComponent("ConditionTreeEditor", true)!

  return (__props.modelValue.kind === 'group')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("header", null, [
          _createElementVNode("strong", null, _toDisplayString(__props.depth ? '（ 条件组 ）' : '条件组合'), 1),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(StudioSelectField, {
              value: __props.modelValue.operator,
              "aria-label": "条件组连接方式",
              onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', { ...__props.modelValue, operator: ($event.target as HTMLSelectElement).value as 'and' | 'or' })))
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createElementVNode("option", { value: "and" }, "且：全部满足", -1),
                _createElementVNode("option", { value: "or" }, "或：任一满足", -1)
              ]))]),
              _: 1
            }, 8, ["value"])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue.children, (child, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: child.id,
            class: "condition-child"
          }, [
            index
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.modelValue.operator === 'and' ? '且 AND' : '或 OR'), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ConditionTreeEditor, {
                "model-value": child,
                depth: __props.depth + 1,
                "onUpdate:modelValue": ($event: any) => (updateChild(index, $event))
              }, null, 8, ["model-value", "depth", "onUpdate:modelValue"]),
              _createElementVNode("button", {
                type: "button",
                class: "remove",
                "aria-label": `删除第 ${index + 1} ${child.kind === 'group' ? '个条件组' : '条条件'}`,
                onClick: ($event: any) => (remove(index))
              }, "删除", 8, _hoisted_5)
            ])
          ]))
        }), 128)),
        (!__props.modelValue.children.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, "此组还没有条件，请添加。"))
          : _createCommentVNode("", true),
        _createElementVNode("footer", null, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (add(false)))
          }, "＋ 添加条件"),
          (__props.depth < 8)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (add(true)))
              }, "＋ 添加括号组"))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createVNode(ConditionValueEditor, {
          "model-value": __props.modelValue.left,
          label: "左值",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (emit('update:modelValue', { ...__props.modelValue, left: $event })))
        }, null, 8, ["model-value"]),
        _createElementVNode("label", _hoisted_8, [
          _cache[7] || (_cache[7] = _createTextVNode("比较关系", -1)),
          _createVNode(StudioSelectField, {
            value: __props.modelValue.operator,
            "aria-label": "比较关系",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (emit('update:modelValue', { ...__props.modelValue, operator: ($event.target as HTMLSelectElement).value as ComparisonOperator })))
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(comparisons, (operator) => {
                return _createElementVNode("option", {
                  key: operator.value,
                  value: operator.value
                }, _toDisplayString(operator.label), 9, _hoisted_9)
              }), 64))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createVNode(ConditionValueEditor, {
          "model-value": __props.modelValue.right,
          label: "右值",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (emit('update:modelValue', { ...__props.modelValue, right: $event })))
        }, null, 8, ["model-value"])
      ]))
}
}

})